/* eslint-disable */
import { apiFetch } from "../auth/apiClient";

export const eventsApi = {
  list: (skip = 0, limit = 50) =>
    apiFetch(`/api/events?skip=${skip}&limit=${limit}`),
  // Merged caller-scoped feed (community + hosting + invited).
  // from/to are "YYYY-MM-DD"; defaults server-side to today → +90d.
  feed: (from, to) => {
    const qs = new URLSearchParams();
    if (from) qs.set("from", from);
    if (to) qs.set("to", to);
    const q = qs.toString();
    return apiFetch(`/api/events/feed${q ? `?${q}` : ""}`, { authRequired: true });
  },
  get: (id) => apiFetch(`/api/events/${id}`),
  create: (body) => apiFetch("/api/events", { method: "POST", body }),
  patch: (id, body) => apiFetch(`/api/events/${id}`, { method: "PATCH", body }),
  delete: (id) => apiFetch(`/api/events/${id}`, { method: "DELETE" }),
};
